exports = module.exports = require("../../../../../../var/www/html/cartaz-pratico/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-d97b5a12],.fade-leave-active[data-v-d97b5a12]{transition:all .4s}.fade-enter[data-v-d97b5a12],.fade-leave-to[data-v-d97b5a12]{opacity:0}.modal[data-v-d97b5a12]{background-color:rgba(0,0,0,.75)}", ""]);

// exports
